import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Prime Food & Financial Consultancy';
const SITE_URL = 'https://primefoodfinancialconsultancy.nl';
const LOGO_URL = `${SITE_URL}/prime-logo.png`;
const DEFAULT_DESCRIPTION = 'Prime Food & Financial Consultancy in the Netherlands. Expert food safety, regulatory compliance, and financial consultancy for businesses and individuals.';

export const SEO = ({ title, description, path = '/', keywords = '' }) => {
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Food Safety & Financial Consultancy in the Netherlands`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook / WhatsApp / LinkedIn */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={LOGO_URL} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={LOGO_URL} />
    </Helmet>
  );
};

export default SEO;
